import { More } from "@/shared/actions/more";
import { useRemoveCompanyDocumentConfirmation } from "@/modules/documents/features/remove-company-document-confirmation/model/use-remove-company-document-confirmation";
import { GET_READ_UNREAD_PERSONS } from "@/modules/documents/widgets/company-document-statistic/api/get-read-unread-persons";

export type CompanyDocumentAnalyticsOptionsProps = {
  ids: string[] | string;
};

export function CompanyDocumentAnalyticsOptions({
  ids,
}: CompanyDocumentAnalyticsOptionsProps) {
  const { remove, loading } = useRemoveCompanyDocumentConfirmation();

  return (
    <More
      menu={{
        items: [
          {
            key: "delete",
            label: (
              <More.Delete
                disabled={loading}
                loading={loading}
                onClick={() =>
                  remove(
                    {
                      ids,
                    },
                    [GET_READ_UNREAD_PERSONS],
                  )
                }
              />
            ),
          },
        ],
      }}
    />
  );
}
